import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-web-awesome-pro',
	templateUrl:'./WebAwesomeProPluginPage.html',
	styles: [],
	styleUrls:['./WebAwesomeProPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WebAwesomeProPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_693 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>web-awesome-pro</artifactId>
</dependency>
\`\`\``;
	mdContent_694 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:web-awesome-pro:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_695 = `\`\`\`java
var page = new WaPage();
page.getHeader().add(new WaText<>().setText("My Application"));
page.getNavigation().add(buildMenuItems());
page.getMain().add(new RouterOutlet<>());
page.getFooter().add(new WaText<>().setText("2026 My Corp"));
\`\`\``;
	mdContent_696 = `\`\`\`java
var page = new WaPage();
page.getHeader().add(new WaText<>().setText("My App"));
page.getNavigation().add(menuItems);
page.getMain().add(content);
page.getFooter().add(footerContent);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
